import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import HeroSection from "../../../layout/HeroSection";
import Listing from "../../lessons/Listing";
import { pageRoutes } from "../../../routes/pageRoutes";
import Loader from "../../../components/other/Loader";
import { fetchPlasticAntweight } from "../../../redux/action/weightAction";
import { useDispatch, useSelector } from "react-redux";
const PlasticAntweights = () => {
  const dispatch = useDispatch();
  const { plasticAntweightsList, isLoading } = useSelector(
    (state) => state?.weightReducer
  );
 
  useEffect(() => {
    dispatch(fetchPlasticAntweight());
  }, []);


  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div>
        <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Plastic Antweights"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Plastic Antweights",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />

        <Listing contentData={plasticAntweightsList} />

        <Footer />
      </div>
    </>
  );
};

export default PlasticAntweights;
